import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2, RefreshCw } from "lucide-react";
import { streamSSE } from "@/lib/stream";
import { fmtDateTime } from "@/lib/crm";
import { useApi } from "@/lib/api";

export const AiSummary = ({ client }) => {
  const [text, setText] = useState(client.ai_summary || "");
  const [at, setAt] = useState(client.ai_summary_at);
  const [busy, setBusy] = useState(false);
  const { data: st } = useApi("/settings");

  const run = async () => {
    setBusy(true);
    setText("");
    try {
      await streamSSE(`/ai/summary/${client.client_id}`, {}, setText);
      setAt(new Date().toISOString());
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  if (st?.ai_enabled === false) return null;
  return (
    <div className="bg-gradient-to-br from-violet-50 to-white border border-violet-200/70 rounded-xl p-5" data-testid="ai-summary">
      <div className="flex items-center justify-between gap-3">
        <p className="font-display font-semibold flex items-center gap-2 text-violet-900"><Sparkles className="h-4 w-4 text-violet-600" />Riepilogo AI</p>
        <button data-testid="ai-summary-btn" onClick={run} disabled={busy}
          className="flex items-center gap-1.5 text-sm rounded-full px-3 py-1.5 bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : text ? <RefreshCw className="h-4 w-4" /> : <Sparkles className="h-4 w-4" />}
          {text ? "Aggiorna" : "Genera riepilogo"}
        </button>
      </div>
      {text ? (
        <div data-testid="ai-summary-text" className="text-sm text-slate-700 mt-3 whitespace-pre-wrap leading-relaxed">{text.replace(/\*\*/g, "")}</div>
      ) : (
        <p className="text-sm text-slate-500 mt-2">L'AI legge pratiche, richiami e storico contatti e ti dice a che punto sei e cosa fare dopo.</p>
      )}
      {at && !busy && <p className="text-[11px] text-slate-400 mt-3">Generato il {fmtDateTime(at)}</p>}
    </div>
  );
};
